import { axios } from '@/utils';

const ROOT = 'cash-register';
const ROOT_TRANSATION = 'transaction';

export const getCashRegisterOpen = async () => {
  const { data,status } = await axios.get(`/${ROOT}/open`);
  if(status === 204){
    return {};
  }
  if (data.message) {
    throw data;
  }
  return data.data;
};
export const getLastCloseCashRegister = async () => (await axios.get(`/${ROOT}/close`)).data.data;

export const getHistoryCashRegister = async (count: number, page: number, dates?: any) =>
  (
    await axios.get(
      `/${ROOT}?count=${count}&page=${page}&initial=${dates?.initial || ''}&last=${
        dates?.last || ''
      }`
    )
  ).data.data;
export const createCashRegisterService = async (values: any) =>
  (await axios.post(`/${ROOT}`, values)).data.data;
export const closeCashRegisterService = (id: string) => async (values: any) =>
  (await axios.put(`/${ROOT}/close-cash-register/${id}`, values)).data;
export const createTransactionService = async (values: any) =>
  (await axios.post(`/${ROOT_TRANSATION}`, values)).data.data;
export const getTransactionByCashRegisterService = (id: string) => async () =>
  (await axios.get(`/${ROOT_TRANSATION}/cashRegister/${id}`)).data.data;
export const getCashRegisterService = (id: string) => async () => {
  const { cashRegister, ...rest } = (await axios.get(`/${ROOT}/findOne/${id}`)).data.data;
  return {
    ...rest,
    ...cashRegister,
  };
};
